module.exports = __webpack_public_path__ + "img/物联网.7f7a5b05.png";